module.exports = __webpack_public_path__ + "img/lightning.1b004dc1.png";